import { OLMapUtility } from "../../../../utility/common/OLMapUtility";
import { LayerFeatureType } from "./LayerFeatureType";
import { OLSourceUtility } from "../../../../utility/common/olSourceUtility";
import { DrawGeometryType } from "../../model/DrawGeometryJs";
import { GeometryExtentUtility } from "../../../../utility/common/GeometryExtentUtility";

/*
 * @Author: your name
 * @Date: 2019-07-11 11:17:45
 * @LastEditTime: 2019-11-19 21:46:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\mainMap\layer\DrawGeometryLayer.js
 */
export class DrawGeometryLayer {

    constructor() {
        this.curMap = null;
    }

    saveGeometry(drawGeometry) {
        if (!drawGeometry) return;

        let geometryType = drawGeometry.type;
        if (geometryType === DrawGeometryType.point) {
            this.saveDrawPoint(drawGeometry);
        }
        else if (geometryType === DrawGeometryType.polyline) {
            this.saveDrawPolyline(drawGeometry);
        }
        else if (geometryType === DrawGeometryType.polygon) {
            this.saveDrawPolygon(drawGeometry);
        }

    }

    addCollectGeometry(drawGeometry) {
        if (!drawGeometry) return;

        let geometryType = drawGeometry.type;
        if (geometryType === DrawGeometryType.point) {
            this.addCollectPoint(drawGeometry);
        }
        else if (geometryType === DrawGeometryType.polyline) {
            this.addCollectPolyline(drawGeometry);
        }
        else if (geometryType === DrawGeometryType.polygon) {
            this.addCollectPolygon(drawGeometry);
        }

    }

    deleteCollectGeometry(drawGeometry)
    {
        if (!drawGeometry) return;

        let geometryId = drawGeometry.id;

        let findFeature = this._findFeatureById(geometryId);

        if (findFeature) {
            let feats = new Array();
            feats.push(findFeature);

            OLSourceUtility.removeFeatures(DrawGeometryLayer.layer.getSource(), feats);
        }



    }

    /**
     * 添加绘制点
     * @param {*} drawGeometry 
     */
    addDrawPoint(drawGeometry) {
        let markerFeatures = new Array();


        let mapCRSCode = OLMapUtility.getProjectionCode(this.curMap);


        let iconStyle = null;

        // tempPoiItem = drawGeometry;

        let tempCoordinate = drawGeometry.coordinates;// [tempPoiItem.x, tempPoiItem.y];
        if (mapCRSCode.toLowerCase() !== drawGeometry.crsCode.toLowerCase()) {
            tempCoordinate = ol.proj.transform(
                tempCoordinate,
                drawGeometry.crsCode,
                mapCRSCode
            );
        }

        iconStyle = new ol.style.Style({
            image: new ol.style.Icon(({
                anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: drawGeometry.image
            }))
        });

        let tempFeature = new ol.Feature(
            {
                geometry: new ol.geom.Point(tempCoordinate),
                featureType: LayerFeatureType.drawLayer_marker,
                featureTypeIsOverlay: true,
                bindingObject: drawGeometry
            }
        );

        tempFeature.setId(drawGeometry.id);
        tempFeature.setStyle(iconStyle);
        markerFeatures.push(tempFeature);

        if (!DrawGeometryLayer.layer) {
            DrawGeometryLayer.layer = this._createLayer();
        }

        DrawGeometryLayer.layer.getSource().addFeatures(markerFeatures);
    }


    /**
     * 添加收藏点
     * @param {*} drawGeometry 
     */
    addCollectPoint(drawGeometry) {

        let markerFeatures = new Array();


        let poiItem = drawGeometry.poi;


        let mapCRSCode = OLMapUtility.getProjectionCode(this.curMap);
        
        let iconStyle = null;
        
        let tempCoordinate = [poiItem.x, poiItem.y];
        if (mapCRSCode.toLowerCase() !== drawGeometry.crsCode.toLowerCase()) {
            tempCoordinate = ol.proj.transform(
                tempCoordinate,
                drawGeometry.crsCode,
                mapCRSCode
            );
        }

        iconStyle = new ol.style.Style({
            image: new ol.style.Icon(({
                anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: drawGeometry.image
            }))
        });

        

        let tempFeature = new ol.Feature(
            {
                geometry: new ol.geom.Point(tempCoordinate),
                featureType: LayerFeatureType.poisearchlayer_marker,
                featureTypeIsOverlay: true,
                bindingObject: poiItem
            }
        );

        tempFeature.setId(drawGeometry.id);
        tempFeature.setStyle(iconStyle);
        markerFeatures.push(tempFeature);

        if (!DrawGeometryLayer.layer) {
            DrawGeometryLayer.layer = this._createLayer();
        }

        DrawGeometryLayer.layer.getSource().addFeatures(markerFeatures);

        this.curMap.getView().setCenter(tempCoordinate);
    }


    /**
     * 删除绘制点
     * @param {*} drawGeometry 
     */
    deleteDrawGeometry(drawGeometry) {
        if (!drawGeometry) return;

        let geometryId = drawGeometry.id;

        let findFeature = this._findFeatureById(geometryId);

        if (findFeature) {
            let feats = new Array();
            feats.push(findFeature);

            OLSourceUtility.removeFeatures(DrawGeometryLayer.layer.getSource(), feats);
        }
    }

    /**
     * 保存绘制点
     * @param {*} drawGeometry 
     */
    saveDrawPoint(drawGeometry) {


        if (!drawGeometry) return;

        let geometryId = drawGeometry.id;

        let findFeature = this._findFeatureById(geometryId);

        if (findFeature) {
            //将绑定的几何图形对象转换为poi对象
            let poiItem = drawGeometry.getPOIResultItem();
            findFeature.set(DrawGeometryLayer.field_featTypeName, LayerFeatureType.poisearchlayer_marker);
            findFeature.set(DrawGeometryLayer.field_bindingObject, poiItem);
        }

    }

    /**
     * 添加绘制线
     * @param {*} drawGeometry 
     */
    addDrawPolyline(drawGeometry) {

        let lineStyle = new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: '#3385ff',
                width: 8,
                lineCap: 'round',
                lineJoin: 'round'
            })
            // ,
            // image: new ol.style.Circle({
            //     radius: 2,
            //     fill: new ol.style.Fill({
            //         color: '#f00'
            //     })
            // })
        })

        let line = new ol.geom.LineString(drawGeometry.coordinates);
        //线要素
        let lineFeature = new ol.Feature(
            {
                geometry: line,
                featureType: LayerFeatureType.drawLayer_polyline,
                featureTypeIsOverlay: true,
                bindingObject: drawGeometry
            });


        lineFeature.setId(drawGeometry.id);
        lineFeature.setStyle(lineStyle);

        let features = new Array();
        features.push(lineFeature);

        DrawGeometryLayer.layer.getSource().addFeatures(features);
    }

    addCollectPolyline(drawGeometry) {
        let lineStyle = new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: '#3385ff',
                width: 8,
                lineCap: 'round',
                lineJoin: 'round'
            })
            // ,
            // image: new ol.style.Circle({
            //     radius: 2,
            //     fill: new ol.style.Fill({
            //         color: '#f00'
            //     })
            // })
        })

        let coordinates = drawGeometry.coordinates;

        let line = new ol.geom.LineString(coordinates);
        //线要素

        let lineFeature = new ol.Feature(
            {
                geometry: line,
                featureType: LayerFeatureType.drawLayer_savedPolyline,
                featureTypeIsOverlay: true,
                bindingObject: drawGeometry
            });


        lineFeature.setId(drawGeometry.id);
        lineFeature.setStyle(lineStyle);

        let features = new Array();
        features.push(lineFeature);

        DrawGeometryLayer.layer.getSource().addFeatures(features);


        let poiExtent = GeometryExtentUtility.GetExtent(coordinates);
        poiExtent = GeometryExtentUtility.expandExtent(poiExtent, 2);

        let mapView = this.curMap.getView();
        mapView.fit(poiExtent, {
            nearest: true
          });
    }


    /**
     * 保存绘制线
     * @param {*} drawGeometry 
     */
    saveDrawPolyline(drawGeometry) {
        if (!drawGeometry) return;

        let geometryId = drawGeometry.id;

        let findFeature = this._findFeatureById(geometryId);

        if (findFeature) {
            findFeature.set(DrawGeometryLayer.field_featTypeName, LayerFeatureType.drawLayer_savedPolyline);
            findFeature.set(DrawGeometryLayer.field_bindingObject, drawGeometry);
        }

    }


    addDrawPolygon(drawGeometry) {
        let fillStyle = new ol.style.Style({

            fill: new ol.style.Fill(
                {
                    color: '#3385ff',
                }
            )
        })

        let ringArray = new Array();
        ringArray.push(drawGeometry.coordinates);
        let pyn = new ol.geom.Polygon(ringArray);
        //面要素
        let polygonFeature = new ol.Feature(
            {
                geometry: pyn,
                featureType: LayerFeatureType.drawLayer_polygon,
                featureTypeIsOverlay: true,
                bindingObject: drawGeometry
            });


        polygonFeature.setId(drawGeometry.id);
        polygonFeature.setStyle(fillStyle);

        let features = new Array();
        features.push(polygonFeature);

        DrawGeometryLayer.layer.getSource().addFeatures(features);
    }

    addCollectPolygon(drawGeometry) {
        let fillStyle = new ol.style.Style({

            fill: new ol.style.Fill(
                {
                    color: '#3385ff',
                }
            )
        })


        let coordinates = drawGeometry.coordinates;

        let ringArray = new Array();
        ringArray.push(coordinates);
        let pyn = new ol.geom.Polygon(ringArray);
        //面要素
        let polygonFeature = new ol.Feature(
            {
                geometry: pyn,
                featureType: LayerFeatureType.drawLayer_savedPolygon,
                featureTypeIsOverlay: true,
                bindingObject: drawGeometry
            });


        polygonFeature.setId(drawGeometry.id);
        polygonFeature.setStyle(fillStyle);

        let features = new Array();
        features.push(polygonFeature);

        DrawGeometryLayer.layer.getSource().addFeatures(features);


        let poiExtent = GeometryExtentUtility.GetExtent(coordinates);
        poiExtent = GeometryExtentUtility.expandExtent(poiExtent, 2);
        let mapView = this.curMap.getView();
        mapView.fit(poiExtent, {
            nearest: true
          });
    }

    saveDrawPolygon(drawGeometry) {

        if (!drawGeometry) return;

        let geometryId = drawGeometry.id;

        let findFeature = this._findFeatureById(geometryId);

        if (findFeature) {
            findFeature.set(DrawGeometryLayer.field_featTypeName, LayerFeatureType.drawLayer_savedPolygon);
            findFeature.set(DrawGeometryLayer.field_bindingObject, drawGeometry);
        }

    }




    /**
     * 创建标记点图层
     */
    _createLayer() {
        let markerSource = new ol.source.Vector({

        });

        //矢量标注图层
        let vectorLayer = new ol.layer.Vector({
            source: markerSource,
            name: 'layer',
            visible: true,
        });

        // let markerSource.addFeatures(markerFeatures);
        // let dd=new POIResultItems();

        return vectorLayer;
    }

    /**
     * 通过id查找
     * @param {*} featureId 
     */
    _findFeatureById(featureId) {

        if (!featureId) return;

        let features = DrawGeometryLayer.layer.getSource().getFeatures();

        let tempFeat = null;
        for (let tempFeatIndex in features) {
            tempFeat = features[tempFeatIndex];
            if (tempFeat.getId() === featureId) {
                return tempFeat;
            }
        }

        return null;
    }

    static createInitFeature(drawGeometry) {

        if(!drawGeometry)return;

        let featType=null;

        let drawType = drawGeometry.type;
        if(drawType===DrawGeometryType.point)
        {
            featType=LayerFeatureType.drawLayer_marker;
        }
        else if(drawType===DrawGeometryType.polyline)
        {
            featType=LayerFeatureType.drawLayer_polyline;
        }
        else if(drawType===DrawGeometryType.polygon)
        {
            featType=LayerFeatureType.drawLayer_polygon;
        }

        let stationFeature = new ol.Feature(
            {
                geometry: null,
                featureType: featType,
                featureTypeIsOverlay: true,
                bindingObject: drawGeometry
            }
        )
        return stationFeature;
    }
    

}


DrawGeometryLayer.layer = null;

DrawGeometryLayer.field_bindingObject = "bindingObject";

DrawGeometryLayer.field_featureTypeIsOverlay = "featureTypeIsOverlay";

DrawGeometryLayer.field_featTypeName = "featureType";